import { useSWRMutation } from '@tiger/swr';
import { IdTypeEnum } from 'types/customer';
import API from 'utils/API';

/**
 * @description 检查身份证件号(是否被使用、格式等)
 * process为modify时必传customer_id参数
 */
export const useCheckIdNo = () => {
    return useSWRMutation(
        {
            url: API.CUSTOMER.checkInfo()
        },
        (params: { id_no: string; id_type: string; process: 'open' | 'modify'; customer_id?: number }) =>
            API.CUSTOMER.checkInfo.post(params).then(res => res.data)
    );
};

/**
 * @description 检查SSN是否已经开过户了
 */
export function useCheckSSN() {
    // TODO 后续server会和checkInfo接口合并，同一功能使用一个接口
    return useSWRMutation(API.CUSTOMER.checkSSN(), (params: { id_no: string; id_type: IdTypeEnum; source?: 'esop' }) =>
        API.CUSTOMER.checkSSN.post(params).then(res => res.data)
    );
}
